import IframeSingleDeepDemo from '../../../../class/service/rv/IframeSingleDeepDemo'
import App from '@class/App.js'
import {getUrlParams} from "../../../../common/util";
import {onBroadcast} from "../../../../api";
import OldVideoDemo from "../../../../class/service/rv/OldVideoDemo";
import SingleOfferTemplatLoader from "../../../../class/templateLoader/SingleOfferTemplatLoader";

window.MTG_LAUNCH_iframeSingleDeepDemo = function (cb) {
    App.onJSBridgeConnected(()=>{

        App.readyToShowAD()
        init()
    })
    //init()
    function init(){
        App.loadTemplate({
            templateClass: IframeSingleDeepDemo,
            templateLoader: SingleOfferTemplatLoader,
            loadCallback: cb
        }).then(({data, tpl})=>{
            App.readyToShowAD()

        }).catch(err=>{
            console.error('promise catch an error:',err)
        })
    }
}
